import { useState } from 'react';

import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';
import Text from '@/shared-components/text/components/Text';

import './styles/ChooseInput.css';

/**
 * This component only allows to be used in a controlled state
 */
export default function ChooseInput({ optionA,optionAText, optionB, optionBText, readOnly, value, onChange, headerInfoIcon='', infoIconDescription='', headerInfoIcon2='', infoIconDescription2='' }) {
  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);

  return (
    <>
      <div className={`choose-input__container element-non-selectable${readOnly ? " read-only" : ""}`}>
        <div className={`choose-input__option${value === optionA ? " active" : ""}`} onClick={()=>{onChange(optionA);}}>
          <Text className="choose-input__text" medium>{optionAText || optionA}</Text>
        </div>

        <div className={`choose-input__option${value === optionB ? " active" : ""}`} onClick={()=>{onChange(optionB);}}>
          <Text className="choose-input__text" medium>{optionBText || optionB}</Text>
        </div>
      </div>
      {infoIconDescription.length > 0 && 
          <InfoIconArtwork
            className="step-accordeon-step-header__info-icon"
            onClick={(status) => setIsInfoIconOpen(status)}
            open={isInfoIconOpen}
            header={headerInfoIcon}
            description={infoIconDescription}
            header2={headerInfoIcon2}
            description2={infoIconDescription2}
          />
      }
    </>
  );
}
